module.exports = __webpack_public_path__ + "static/img/banner03.0437bd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/banner03.png
// module id = 929
// module chunks = 0